<!-- This needs refactoring, it's confusing because we no longer need a "minimal" version anymore
Eventually this should be replaced with the score card design  -->
<template>
    <v-container fluid style="position:relative">
        <v-row class="pa-0">
            <v-col cols="12" class="pt-0">
                <v-row wrap>
                    <v-col cols="12" class="pt-0">
                        <div class="q-display-2 inline-form-left full-width">
                            <span v-if="agent.IsAgencyOwner">Agency Production Stats</span>
                            <span v-else>Production Stats</span>
                            <q-tooltip-details v-else>
                                Stats updated weekly, but placed data is updated monthly during the following month when data is available from the carriers.
                                <span v-if="agent.IsAgencyOwner"> These are master aggregate production stats. </span>
                            </q-tooltip-details>
                        </div>
                        <div class="full-width">
                            <p class="body-2 full-width">Quility HQ data is synced nightly and does not provide real-time data. Please reference Opt! for the most up-to-date metrics.</p>
                        </div>
                        <div v-if="canDispute">
                            <!-- In dispute range -->
                            <v-btn color="q_green_1 white--text" depressed transition="scroll-y-transition" @click="launchDisputeForm"><strong>Dispute</strong></v-btn><br>
                        </div>
                        <!-- <div v-else> -->
                            <!-- Out of dispute range -->
                        <!-- </div> -->
                    </v-col>
                    <v-col cols="12" class="pt-0">
                        <div class="inline-form-left">
                            <q-business-time-period-select :disabled="loading" v-model="datePeriod" label="Time Period" :allow-current="true" stateKey="stat"></q-business-time-period-select>
                        </div>
                    </v-col>
                    <v-col id="v-prod-1" cols="12" :sm="cols">
                        <q-stats-submitted-chart :agent="agent" :start-date="datePeriod.startDateFormat" :end-date="datePeriod.endDateFormat" :time-period="datePeriod.period" :goal="promotionLevelAPV"></q-stats-submitted-chart>
                        <q-stats-unique-writers-chart :agent="agent" :start-date="datePeriod.startDateFormat" :end-date="datePeriod.endDateFormat" :time-period="datePeriod.period" :goal="promotionLevelUW"></q-stats-unique-writers-chart>
                        <div class="stat pb-4">
                            <div v-if="agent.IsAgencyOwner">
                                <div v-if="agent.LeadershipLevel != 'Agency Owner'">
                                    <q-stats-close-ratio-chart :agent="agent" :start-date="datePeriod.startDateFormat" :end-date="datePeriod.endDateFormat" :time-period="datePeriod.period" :goal="promotionLevelAPV" stat-type="Master"></q-stats-close-ratio-chart>
                                </div>
                                <div v-else>
                                    <q-stats-close-ratio-chart :agent="agent" :start-date="datePeriod.startDateFormat" :end-date="datePeriod.endDateFormat" :time-period="datePeriod.period" :goal="promotionLevelAPV" stat-type="Baseshop"></q-stats-close-ratio-chart>
                                </div>
                            </div>
                            <div v-else>
                                <q-stats-close-ratio-chart :agent="agent" :start-date="datePeriod.startDateFormat" :end-date="datePeriod.endDateFormat" :time-period="datePeriod.period" :goal="promotionLevelAPV" stat-type="PersonalProduction"></q-stats-close-ratio-chart>
                            </div>
                            <p class="stat-label">Submitted business {{datePeriod.period}} is {{datePeriod.startDateFormat}} through {{datePeriod.endDateFormat}}. Close Ratio is 6-week rolling average from {{datePeriod.startDateFormat}}. Current stats are synced with Opt nightly.</p>
                        </div>
                    </v-col>
                    <v-col cols="12" :sm="cols" class="px-4">
                        <q-stats-placed-chart :agent="agent" :start-date="datePeriod.startDateFormat" :end-date="datePeriod.endDateFormat" :time-period="datePeriod.period" :goal="promotionLevelAPV"></q-stats-placed-chart>
                    </v-col>
                </v-row>
            </v-col>
            <v-col id="v-monthly-3" cols="12" v-if="stats.salesData.length > 0 && !loading">
                <v-list-item one-line>
                    <v-list-item-content>
                        <v-list-item-title class="q-display-2">Monthly Sales Data
                            <q-tooltip-details>
                                <span class="q-subtitle">This stat is updated weekly.<br>Note that historical data for 'submits' will be available from May 2020 onward. Placed data is updated monthly during the following month when data is available from the carriers.</span>
                            </q-tooltip-details>
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <q-monthly-sales-chart :data="stats.salesData" :placed-data="stats.placedData"></q-monthly-sales-chart>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import QuilityAPI from '@/store/API/QuilityAPI.js'
import QProgressStat from '@/components/stats/QProgressStat.vue';
import QComparisonStat from '@/components/stats/QComparisonStat.vue';
import QMonthlySalesChart from '@/components/charts/QMonthlySalesChart.vue';
import QPromotionTrackerChart from '@/components/charts/QPromotionTrackerChart.vue';
import QTooltipDetails from '@/components/utils/QTooltipDetails.vue';

import User from '@/store/Models/User'
import PromotionLevels from '@/store/PromotionLevels.json'
import QBusinessTimePeriodSelect from '@/components/utils/QBusinessTimePeriodSelect.vue';

import QStatsSubmittedChart from '@/components/charts/QStatsSubmittedChart.vue';
import QStatsCloseRatioChart from '@/components/charts/QStatsCloseRatioChart.vue';
import QStatsPlacedChart from '@/components/charts/QStatsPlacedChart.vue';
import QStatsUniqueWritersChart from '@/components/charts/QStatsUniqueWritersChart.vue';
import { isDisputeTimePeriod } from '@/components/utils/BusinessTimeDateDiff'
export default {
    props: {
        'agent': {
            type: Object,
            default: function() {
                return {}
            },
        },
    },
    data: function() {
        return {
            stats: {
                "rollingCloseRatio6weeks": {},
                "rollingCloseRatioPrevious6weeks": {},
                "weeklyProduction": {},
                "weeklyProductionPrevious": {},
                "salesData": [],
                "placedData": [],
            },
            loading: false,
            datePeriod: { label: 'Current Month' },
            statType: null,
        }
    },
    mounted: function() {
        this.loadData()
    },
    computed: {
        promotionLevelAPV: function() {
            return this.promotionLevel().APV;
        },
        promotionLevelPlaced: function() {
            return this.promotionLevel().MinimumAPV;
        },
        promotionLevelUW: function() {
            return this.promotionLevel().UniqueWriters;
        },
        cols: function() {
            if (this.minimal) {
                return 12
            }
            return 6
        },
        canDispute: function() {
            return isDisputeTimePeriod()
        },
    },
    methods: {
        promotionLevel: function() {

            //ensure that contract level is set
            // before performing search
            const contractLevel = this.agent.ContractLevel ? this.agent.ContractLevel : this.agent.Agent.ContractLevel

            for (var i = 0; i < PromotionLevels.length; i++) {
                if (contractLevel == PromotionLevels[i].CommissionLevel) {
                    return PromotionLevels[i]
                }
            }
            return {};
        },
        loadData: function() {
            if (typeof this.agent == 'undefined') {
                return;
            }
            var g = this
            this.loading = true;

            var params = {}; //you can add "type" to get a certain type of stats - baseshop or total agency or production

            var params = {
                type: this.statType,
                startDate: null,
                endDate: null,
                timePeriod: 'month'
            };

            QuilityAPI.getStatRangeCombined(this.agent.AgentCode, params).then(function(json) {
                g.loading = false;
                g.$set(g, 'stats', json.data);
            }).catch(function(err) {
                if (typeof err == 'undefined') {
                    return;
                }
                if (err.message == "Aborted") {
                    return;
                }
                g.loading = false;
                if (err.errors == "Page not found") {
                    g.showError("You don't appear to have any stats.");
                    return
                }
                g.showError(err.message);
            })
        },
        loadAgentStats(agentcode) {
            this.$router.push('/my_stats/agents/' + agentcode)
        },
        launchDisputeForm() {
            // open link to dispute form
            // housed in jot forms
            window.open('https://form.jotform.com/211966371426055', '_blank');
        },
    },
    watch: {
        'agent.AgentCode': function(newV) {
            this.stats = {
                "rollingCloseRatio6weeks": {},
                "rollingCloseRatioPrevious6weeks": {},
                "monthlyProduction": {},
                "monthlyProductionPrevious": {},
                "salesData": [],
            }
            this.$nextTick(this.loadData);
        },
    },
    components: {
        QProgressStat,
        QComparisonStat,
        QMonthlySalesChart,
        QPromotionTrackerChart,
        QTooltipDetails,
        QBusinessTimePeriodSelect,

        QStatsSubmittedChart,
        QStatsCloseRatioChart,
        QStatsPlacedChart,
        QStatsUniqueWritersChart
    }
}

</script>
<style>
.v-tour__target--highlighted.v-tour__target--relative {
    z-index: 1;
}

</style>
